export const appLightPalette = {
  pageBg: '#f5f7fb',
  surfaceBg: '#ffffff',
  surfaceBgAlt: '#f8fafc',
  surfaceElevatedBg: '#ffffff',
  border: '#e2e8f0',
  borderSoft: 'rgba(15, 23, 42, 0.06)',
  text: '#0f172a',
  textSecondary: '#64748b',
  itemText: '#334155',
  itemHoverBg: '#e8eef7',
  primary: '#1d4ed8',
  primaryStrong: '#2563eb',
  primarySoftBg: '#eff6ff',
  primarySoftBgAlt: '#dbeafe',
  primaryBorder: 'rgba(37, 99, 235, 0.14)',
  disabledBg: '#dde3ec',
  disabledBorder: '#cbd5e1',
  disabledText: '#64748b',
  shadowSoft:
    '0 24px 60px rgba(15, 23, 42, 0.12), 0 2px 10px rgba(15, 23, 42, 0.04)',
  shadowSidebar: '10px 0 30px rgba(15, 23, 42, 0.035)',
  shadowDropdown:
    '0 18px 40px rgba(15, 23, 42, 0.12), 0 2px 8px rgba(15, 23, 42, 0.05)',
};

export const appDarkPalette = {
  pageBg:
    'radial-gradient(circle at 22% 18%, rgba(37, 99, 235, 0.12), transparent 30rem), linear-gradient(145deg, #07101f 0%, #0a1221 52%, #08111f 100%)',
  surfaceBg:
    'linear-gradient(145deg, rgba(31, 43, 63, 0.98), rgba(24, 36, 55, 0.98))',
  surfaceBgAlt: 'rgba(30, 41, 59, 0.9)',
  surfaceElevatedBg: '#1f2937',
  controlBg: '#253043',
  border: '#475569',
  borderSoft: 'rgba(148, 163, 184, 0.32)',
  text: '#f8fafc',
  textSecondary: '#94a3b8',
  itemText: '#cbd5e1',
  itemHoverBg: 'rgba(51, 65, 85, 0.82)',
  primary: '#60a5fa',
  primaryStrong: '#2563eb',
  primarySoftBg: 'rgba(96, 165, 250, 0.16)',
  primarySoftBgAlt: 'rgba(96, 165, 250, 0.24)',
  primaryBorder: 'rgba(147, 197, 253, 0.26)',
  disabledBg: '#0b1422',
  disabledBorder: 'rgba(71, 85, 105, 0.5)',
  disabledText: '#5b6b82',
  shadowSoft:
    '0 26px 70px rgba(0, 0, 0, 0.42), 0 0 0 1px rgba(255, 255, 255, 0.03)',
  shadowSidebar: '10px 0 30px rgba(0, 0, 0, 0.2)',
  shadowDropdown:
    '0 18px 40px rgba(0, 0, 0, 0.35), 0 2px 8px rgba(0, 0, 0, 0.25)',
};
